import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const Navbar: React.FC = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')!) : null;

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setMenuOpen(false);
    navigate('/');
  };

  const closeMenu = () => setMenuOpen(false);

  return (
    <>
      <style>{`
        .qb-nav {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 15px 30px;
          background-color: #2c3e50;
          color: white;
          position: relative;
          z-index: 1000;
        }
        .qb-logo {
          font-size: 24px;
          font-weight: bold;
          color: white;
          text-decoration: none;
          flex-shrink: 0;
        }
        .qb-links {
          display: flex;
          align-items: center;
          gap: 20px;
        }
        .qb-link {
          color: white;
          text-decoration: none;
          font-size: 15px;
        }
        .qb-pricing-link {
          color: #f1c40f;
          text-decoration: none;
          font-weight: bold;
          font-size: 15px;
        }
        .qb-user {
          color: #3498db;
          font-size: 15px;
        }
        .qb-logout {
          padding: 8px 16px;
          background-color: #e74c3c;
          color: white;
          border: none;
          border-radius: 5px;
          cursor: pointer;
          font-size: 14px;
        }
        .qb-hamburger {
          display: none;
          flex-direction: column;
          gap: 5px;
          cursor: pointer;
          padding: 5px;
          background: none;
          border: none;
          z-index: 1001;
        }
        .qb-hamburger span {
          display: block;
          width: 28px;
          height: 3px;
          background-color: white;
          border-radius: 3px;
          transition: all 0.3s ease;
        }
        .qb-hamburger.open span:nth-child(1) {
          transform: rotate(45deg) translate(5px, 6px);
        }
        .qb-hamburger.open span:nth-child(2) {
          opacity: 0;
        }
        .qb-hamburger.open span:nth-child(3) {
          transform: rotate(-45deg) translate(5px, -6px);
        }
        .qb-overlay {
          display: none;
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0,0,0,0.5);
          z-index: 998;
        }
        .qb-overlay.open {
          display: block;
        }
        @media (max-width: 768px) {
          .qb-nav {
            padding: 12px 20px;
          }
          .qb-hamburger {
            display: flex;
          }
          .qb-links {
            display: none;
            position: fixed;
            top: 0;
            right: 0;
            width: 280px;
            height: 100vh;
            background-color: #2c3e50;
            flex-direction: column;
            align-items: flex-start;
            padding: 80px 30px 30px;
            gap: 0;
            z-index: 999;
            box-shadow: -5px 0 20px rgba(0,0,0,0.3);
            overflow-y: auto;
          }
          .qb-links.open {
            display: flex;
          }
          .qb-link, .qb-pricing-link, .qb-user {
            font-size: 18px;
            padding: 15px 0;
            width: 100%;
            border-bottom: 1px solid rgba(255,255,255,0.1);
          }
          .qb-logout {
            margin-top: 15px;
            width: 100%;
            padding: 14px;
            font-size: 16px;
            text-align: center;
          }
        }
      `}</style>

      <nav className="qb-nav">
        <Link to={token ? '/dashboard' : '/'} className="qb-logo" onClick={closeMenu}>
          🚀 QuoteBid
        </Link>

        <button
          className={`qb-hamburger ${menuOpen ? 'open' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <div className={`qb-links ${menuOpen ? 'open' : ''}`}>
          {!token ? (
            <>
              <Link to="/pricing" className="qb-link" onClick={closeMenu}>Pricing</Link>
              <Link to="/login" className="qb-link" onClick={closeMenu}>Login</Link>
              <Link to="/register" className="qb-link" onClick={closeMenu}>Register</Link>
            </>
          ) : (
            <>
              {user?.user_type === 'customer' && (
                <>
                  <Link to="/new-request" className="qb-link" onClick={closeMenu}>Post Request</Link>
                  <Link to="/my-requests" className="qb-link" onClick={closeMenu}>My Requests</Link>
                </>
              )}
              {user?.user_type === 'business' && (
                <>
                  <Link to="/requests" className="qb-link" onClick={closeMenu}>Browse Requests</Link>
                  <Link to="/dashboard" className="qb-link" onClick={closeMenu}>Dashboard</Link>
                  <Link to="/my-quotes" className="qb-link" onClick={closeMenu}>My Quotes</Link>
                  <Link to="/pricing" className="qb-pricing-link" onClick={closeMenu}>💎 Upgrade</Link>
                </>
              )}
              <Link to="/settings" className="qb-link" onClick={closeMenu}>⚙️ Settings</Link>
              <span className="qb-user">Hi, {user?.name}!</span>
              <button onClick={handleLogout} className="qb-logout">Logout</button>
            </>
          )}
        </div>
      </nav>

      <div
        className={`qb-overlay ${menuOpen ? 'open' : ''}`}
        onClick={closeMenu}
      />
    </>
  );
};

export default Navbar;